import type React from "react";

import type { NavigationTabProps } from "./NavigationTab";

import { StyledTabContainer } from "./NavigationTabs.styled";

interface NavigationTabContainerProps {
  children: React.ReactElement<NavigationTabProps> | React.ReactElement<NavigationTabProps>[];
  className?: string;
  dataCy?: string;
}

export const NavigationTabContainer: React.FC<NavigationTabContainerProps> = ({
  children,
  className,
  dataCy,
}) => (
  <StyledTabContainer className={className} data-cy={dataCy}>
    {children}
  </StyledTabContainer>
);
